import { render, staticRenderFns } from "./SurveyBanner.vue?vue&type=template&id=74a2b667&scoped=true"
import script from "./SurveyBanner.vue?vue&type=script&lang=js"
export * from "./SurveyBanner.vue?vue&type=script&lang=js"
import style0 from "./SurveyBanner.vue?vue&type=style&index=0&id=74a2b667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2b667",
  null
  
)

export default component.exports